import Rails from '@rails/ujs'
Rails.start()

import '~/modules/recaptcha'
import '~/modules/shoelace'

// Controller Roots
import '~/controllers'
